package com.eladfinish.bible.contest.screens.search.api

import com.eladfinish.contract.analytics.SearchAnalyticsEvent
import io.ktor.client.HttpClient
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

interface SearchAnalyticsApi {
    suspend fun trackSearch(
        event: SearchAnalyticsEvent,
    )
}

class KtorSearchAnalyticsApi(
    private val httpClient: HttpClient,
    private val baseUrl: String,
) : SearchAnalyticsApi {

    override suspend fun trackSearch(
        event: SearchAnalyticsEvent,
    ) {
        httpClient.post(
            urlString = "$baseUrl/analytics/search",
        ) {
            contentType(ContentType.Application.Json)
            setBody(event)
        }
    }
}
